/**
 * Enhanced Inventory Countdown with Same-Day Delivery Timer
 * Handles real-time countdown updates and Danish timezone considerations
 * Now includes fake limited stock and next-day delivery timer
 */

class EnhancedInventoryCountdown {
  constructor(element) {
    this.element = element;
    this.currentInventory = parseInt(element.dataset.currentInventory) || 0;
    this.maxInventory = parseInt(element.dataset.maxInventory) || 10;
    this.deadlineHour = parseInt(element.dataset.deadlineHour) || 14;
    this.deadlineMinute = parseInt(element.dataset.deadlineMinute) || 0;
    this.enableWeekend = element.dataset.enableWeekend === 'true';
    this.timezoneOffset = element.dataset.timezoneOffset || '+0100';
    this.enableFakeLimitedStock = element.dataset.enableFakeLimitedStock === 'true';
    this.fakeStockQuantity = parseInt(element.dataset.fakeStockQuantity) || 5;
    this.sameDayText = element.dataset.sameDayText || 'Order within the next <strong>${this.deadlineHour} hours</strong> for same day shipping';
    this.nextDayText = element.dataset.nextDayText || 'Order within the next <strong>${this.deadlineHour} hours</strong> for next business day shipping';

    

    
    this.init();
  }

  init() {
    this.updateCountdown();
    this.startTimer();
    this.updateInventoryDisplay();
  }

  startTimer() {
    // Update every minute for delivery countdown
    setInterval(() => {
      this.updateCountdown();
    }, 60000);
  }

  updateCountdown() {
    // Simple logic: check if deadline has passed
    const now = new Date();
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();
    const currentTimeMinutes = currentHour * 60 + currentMinute;
    const deadlineTimeMinutes = this.deadlineHour * 60 + this.deadlineMinute;
    
    const countdownElement = this.element.querySelector('.delivery-countdown__text');
    if (countdownElement) {
      if (currentTimeMinutes < deadlineTimeMinutes) {
        // Before deadline: show same-day delivery
        countdownElement.innerHTML = this.sameDayText;
      } else {
        // After deadline: show next-day delivery
        countdownElement.innerHTML = this.nextDayText;
      }
    }
  }



  updateInventoryDisplay(newInventory) {
    if (newInventory !== undefined) {
      this.currentInventory = newInventory;
    }

    // Use fake stock quantity if enabled, otherwise use real inventory
    const displayQuantity = this.enableFakeLimitedStock ? this.fakeStockQuantity : this.currentInventory;
    
    const quantityElement = this.element.querySelector('.quantity__number');
    if (quantityElement) {
      quantityElement.textContent = displayQuantity;
    }

    // Update visibility based on inventory level or fake stock setting
    if (this.enableFakeLimitedStock || this.currentInventory <= 0) {
      this.element.classList.add('low-stock');
      this.element.classList.remove('out-of-stock');
    } else if (this.currentInventory <= this.maxInventory) {
      this.element.classList.add('low-stock');
      this.element.classList.remove('out-of-stock');
    } else {
      this.element.classList.remove('low-stock', 'out-of-stock');
    }
  }
}

// Initialize all enhanced inventory countdown elements
document.addEventListener('DOMContentLoaded', () => {
  const countdownElements = document.querySelectorAll('[data-enhanced-inventory-countdown]');
  countdownElements.forEach(element => {
    new EnhancedInventoryCountdown(element);
  });
});

// Export for use in other scripts
if (typeof module !== 'undefined' && module.exports) {
  module.exports = EnhancedInventoryCountdown;
}
